<template>
  <div>
    <h1 v-if="msg">{{msg}}</h1>
  </div>
</template>

<script>
import SecurityService from "../../services/salesforce/SecurityService";
import { mapMutations } from "vuex";
import XippAuthService from "@/services/auth/XippAuthService";
export default {
  data () {
    return {
      msg: "",
    };
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    getvalue (fields, name) {
      if (fields.some((s) => s.key == name)) {
        return fields.find((f) => f.key == name).value.replace("undefined", "");
      } else {
        return "";
      }
    },
    getphone (phone) {
      phone = phone.replace("+55", "");
      phone = phone.replace("(", "");
      phone = phone.replace(")", "");
      phone = phone.replace("-", "");
      return phone.trim();
    },
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";

        localStorage.setItem(sessionKey, this.$route.query.token);
        this.toogleDialogLoading(true);

        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
      }
    },
  },
  async created () {
    this._securityService = new SecurityService();
    this._xippAuthService = new XippAuthService();

    if (!this.$route.query.token) {
      this.msg = "Não autorizado";
    } else {
      localStorage.setItem("access_token", this.$route.query.token);
      localStorage.removeItem("current_addfields");
      localStorage.removeItem("current_quote");
      localStorage.removeItem("user_current");
      
      await this.loadJWTToken();

      var origin = this.$route.query.origin;
      //var personType = this.$route.query.personType;
      //var id = this.$route.query.id ? this.$route.query.id : 0; // 0 -  plano de saude

      this.toogleDialogLoading(true);
      var ehPj = false;
      var temFields = false;
      var quoteId = "";

      this._securityService
        .findUserCurrent()
        .then((res) => {
          if (
            res.data.authenticated &&
            res.data.principal &&
            res.data.principal.user &&
            res.data.principal.user.additionalFields &&
            res.data.principal.user.additionalFields.length > 0
          ) {
            let fields = res.data.principal.user.additionalFields;
            let cnpj = this.getvalue(fields, "customer.cnpj");
            let cpf = this.getvalue(fields, "customer.cpf");
            let email = this.getvalue(fields, "customer.email");
            let name = this.getvalue(fields, "customer.nome");
            let phone = this.getvalue(fields, "customer.telefone");
            let celular = this.getvalue(fields, "customer.celular");
            let companyName = this.getvalue(fields, "customer.nomeEmpresa");
            let userId = this.getvalue(fields, "salesforce.user.id");

            quoteId = this.getvalue(fields, "customer.quoteId");
            let accountId = this.getvalue(fields, "customer.accountId");
            let opportunityId = this.getvalue(fields, "customer.opportunityId");
            let leadId = this.getvalue(fields, "customer.leadId");

            localStorage.setItem(
              "current_addfields",
              JSON.stringify({
                quoteId,
                accountId,
                opportunityId,
                leadId,
                userId,
              })
            );

            let rtDeveloperName = this.getvalue(
              fields,
              "customer.rtDeveloperName"
            );

            temFields = cnpj || cpf || rtDeveloperName;

            if (["business_customer", "business"].includes(rtDeveloperName)) {
              ehPj = true;
              cpf = null;
            } else if (
              ["person_customer", "person"].includes(rtDeveloperName)
            ) {
              ehPj = false;
              cnpj = null;
            } else if (!ehPj) {
              ehPj = cnpj && cnpj.length > 0;
            }

            let phonePrefix = "";
            if (phone && phone.length > 9) {
              phonePrefix = this.getphone(phone).substring(0, 2).trim();
              phone = this.getphone(phone).substring(2).trim();
            }

            let Prefix = "";
            if (celular && celular.length > 9) {
              Prefix = this.getphone(celular).substring(0, 2).trim();
              celular = this.getphone(celular).substring(2).trim();
            }

            // se não tiver telefone
            // preencher com celular se vier
            if (!phone) {
              if (celular) {
                phonePrefix = Prefix;
                phone = celular;
              }
            }

            //desestruturando usercurrent
            localStorage.setItem(
              "user_current",
              JSON.stringify({
                name,
                companyName,
                cpf,
                cnpj,
                email,
                phone,
                phonePrefix,
                userId,
                quoteId,
                accountId,
                leadId,
                opportunityId,
              })
            );

            //Study Parameters
            let study = {};
            study.lead = {};
            study.lead.id = this.getvalue(fields, "salesforce.lead.id");
            study.salesChannelId = this.getvalue(fields, "salesforce.sales.channel.id");
            study.lead.businnesId = this.getvalue(fields, "salesforce.lead.business.id");
            study.lead.businnesName = this.getvalue(fields, "salesforce.lead.business.name");
            study.lead.contactName = this.getvalue(fields, "salesforce.lead.contact.name");
            study.lead.contactPhone = this.getvalue(fields, "salesforce.lead.contact.phone");
            study.lead.contactEmail = this.getvalue(fields, "salesforce.lead.contact.email");
            study.quoteId = this.getvalue(fields, "salesforce.quote.id");

            localStorage.setItem(
              "study",
              JSON.stringify(study)
            );

            
          } else {
            localStorage.removeItem("user_current");
            localStorage.removeItem("study");
          }
        })
        .catch((reason) => {
          console.log("ERRO: ");
          console.log(JSON.stringify(reason));
        })
        .finally(() => {
          this.toogleDialogLoading(false);
          if (quoteId) {
            this.$util.link("quote", {}, { quoteId });
          } else {
            var url = "";
            // customer
            if (temFields) {
              url = "personType=" + (ehPj ? "pj" : "pf") + "&";
            }

            // origin
            if (origin) {
              url += "origin=" + origin;
            }

            //
            this.$util.linkRedirect(`?${url}`);
          }
        });
    }
  },
};
</script>
<style>
h1 {
  display: flex;
  justify-content: center;
  justify-items: center;
  margin-top: 200px;
  color: var(--v-foreground-base);
}
</style>
